/*global google*/

import * as React from "react";
import { MapComponentProps } from "./map";
import { Location, mapLocation } from "./location";

interface PolyLineProps extends Replace<google.maps.PolylineOptions, MapComponentProps & { path?:  Location[] }> {
}

export class PolyLine extends React.PureComponent<PolyLineProps>{

    static propTypes = {
        //TODO: MapComponentProps
    }

    static displayName = "GoogleMaps.PolyLine"

    private polyLine?: google.maps.Polyline;

    componentDidMount() {
        this.polyLine = new google.maps.Polyline(this.getOptions());
    }

    componentDidUpdate() {
        this.polyLine && this.polyLine.setOptions(this.getOptions());
    }

    componentWillUnmount() {
        this.polyLine && this.polyLine.setMap(null);
    }

    render(): null {
        return null;
    }

    private getOptions(): google.maps.PolylineOptions {
        const {
            children,
            path,
            ...props
        } = this.props;

        return {
            path: path && mapLocation(path),
            ...props
        }
    }
}
